var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "eu-pb_5" }, [
    _c(
      "div",
      { staticClass: "emd-container _highlight_header" },
      [
        _c(
          "div",
          { staticClass: "emd-container__header" },
          [_c("PaymentMethodTitle")],
          1
        ),
        _c(
          "div",
          { staticClass: "eu-pa_3" },
          [
            _c("LastTransactionInfos", {
              attrs: {
                "payment-method": _vm.treatedPaymentMethod,
                "last-transaction-id": _vm.lastTransaction.id,
                "last-transaction-card": _vm.lastTransaction.card,
              },
            }),
          ],
          1
        ),
        _vm.hasPaymentCards
          ? _c("PaymentCards", {
              attrs: {
                "last-transaction-id": _vm.lastTransaction.id,
                "last-transaction-card": _vm.lastTransaction.card,
                installments: _vm.lastTransaction.installments,
                "merchant-id": _vm.merchantId,
                "account-id": _vm.accountId,
                "customer-id": _vm.customerId,
              },
            })
          : _c(
              "section",
              { staticClass: "emd-card-grid" },
              [
                _vm.hasBoleto
                  ? _c("Boleto", {
                      attrs: { "last-transaction": _vm.lastTransaction },
                    })
                  : _vm._e(),
                _vm.hasBankTransfer
                  ? _c("BankTransfer", {
                      attrs: {
                        "last-transaction": _vm.lastTransaction,
                        "due-at": _vm.charge.due_at,
                      },
                    })
                  : _vm._e(),
                _vm.hasCash
                  ? _c("Cash", {
                      attrs: { "last-transaction": _vm.lastTransaction },
                    })
                  : _vm._e(),
                _vm.hasSafetyPay
                  ? _c("SafetyPay", {
                      attrs: { "last-transaction": _vm.lastTransaction },
                    })
                  : _vm._e(),
                _vm.hasPix
                  ? _c("Pix", {
                      attrs: {
                        "charge-id": _vm.charge.id,
                        transactions: _vm.charge.transactions,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }